import React from "react";
import { getCardUrl } from "@/utils/utils";
import { Row, Col, Card, Tag, Alert } from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

{
    /* OFC */
}
export default function HandDetailOfc ({
    handCardData = {},
    searchPlayer = {},
    language = {},
}) {
    searchPlayer = {
        uid1: searchPlayer.uid1 ? searchPlayer.uid1 : undefined,
        uid2: searchPlayer.uid2 ? searchPlayer.uid2 : undefined,
    };
    return (
        <>
            {/* result */}
            {handCardData.rounds_result && handCardData.rounds_result.length && (
                <>
                    {handCardData.rounds_result.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 2}>
                                        <span>
                                            {item.first_score} / {item.all_kill_score}
                                        </span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 2}>
                                        {item.fantasy && <span>FANTASY</span>}
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 2} align={isMobileDevice() ? "left" : "right"}>
                                        <span
                                            className="fs18"
                                            style={{
                                                color:
                                                    item.score > 0
                                                        ? "#3f8600"
                                                        : item.score < 0
                                                            ? "#cf1322"
                                                            : "",
                                            }}
                                        >
                                            {item.score > 0 ? "+" : ""}
                                            {item.score}
                                        </span>
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </>
            )}

            {/* 首轮 */}
            {handCardData.first_info && handCardData.first_info.length && (
                <Card
                    className="mt20"
                    title={
                        <Row type="flex" align="middle">
                            <Col span={12}>
                                <span>{language["firstRound"]}</span>
                            </Col>
                            <Col span={12} align="right">
                                <span>{language["fold"]}</span>
                            </Col>
                        </Row>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.first_info.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4} align={isMobileDevice() ? "left" : "right"}>
                                        {item.dis_poker &&
                                            item.dis_poker.length &&
                                            item.dis_poker.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}

            {/* 第二轮 */}
            {handCardData.second_info && handCardData.second_info.length && (
                <Card
                    className="mt10"
                    title={
                        <Row type="flex" align="middle">
                            <Col span={12}>
                                <span>{language["twoRound"]}</span>
                            </Col>
                            <Col span={12} align="right">
                                <span>{language["fold"]}</span>
                            </Col>
                        </Row>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.second_info.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4} align={isMobileDevice() ? "left" : "right"}>
                                        {item.dis_poker &&
                                            item.dis_poker.length &&
                                            item.dis_poker.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}

            {/* 第三轮 */}
            {handCardData.third_info && handCardData.third_info.length && (
                <Card
                    className="mt10"
                    title={
                        <Row type="flex" align="middle">
                            <Col span={12}>
                                <span>{language["threeRound"]}</span>
                            </Col>
                            <Col span={12} align="right">
                                <span>{language["fold"]}</span>
                            </Col>
                        </Row>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.third_info.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4} align={isMobileDevice() ? "left" : "right"}>
                                        {item.dis_poker &&
                                            item.dis_poker.length &&
                                            item.dis_poker.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}

            {/* 第四轮 */}
            {handCardData.fourth_info && handCardData.fourth_info.length && (
                <Card
                    className="mt10"
                    title={
                        <Row type="flex" align="middle">
                            <Col span={12}>
                                <span>{language["fourRound"]}</span>
                            </Col>
                            <Col span={12} align="right">
                                <span>{language["fold"]}</span>
                            </Col>
                        </Row>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.fourth_info.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4} align={isMobileDevice() ? "left" : "right"}>
                                        {item.dis_poker &&
                                            item.dis_poker.length &&
                                            item.dis_poker.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}

            {/* 第五轮 */}
            {handCardData.fifth_info && handCardData.fifth_info.length && (
                <Card
                    className="mt10"
                    title={
                        <Row type="flex" align="middle">
                            <Col span={12}>
                                <span>{language["fiveRound"]}</span>
                            </Col>
                            <Col span={12} align="right">
                                <span>{language["fold"]}</span>
                            </Col>
                        </Row>
                    }
                    type="inner"
                    size="small"
                >
                    {handCardData.fifth_info.map((item, index) => (
                        <Alert
                            className="mt10"
                            type={
                                item.user_info.indexOf(searchPlayer.uid1) > -1
                                    ? "info"
                                    : item.user_info.indexOf(searchPlayer.uid2) > -1
                                        ? "error"
                                        : "none"
                            }
                            message={
                                <Row
                                    type="flex"
                                    align="middle"
                                    key={index}
                                >
                                    <Col span={isMobileDevice() ? 24 : 6}>
                                        {index === 0 && <Tag color="geekblue">UTG</Tag>}
                                        {index === 1 && <Tag color="geekblue">MP</Tag>}
                                        {index === 2 && <Tag color="geekblue">D</Tag>}
                                        <span>{item.user_info}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.first_cards &&
                                            item.first_cards.length &&
                                            item.first_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.first_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 5}>
                                        {item.second_cards &&
                                            item.second_cards.length &&
                                            item.second_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.second_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4}>
                                        {item.third_cards &&
                                            item.third_cards.length &&
                                            item.third_cards.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                        <span className="ml10">{item.third_poker_type_score}</span>
                                    </Col>
                                    <Col span={isMobileDevice() ? 24 : 4} align={isMobileDevice() ? "left" : "right"}>
                                        {item.dis_poker &&
                                            item.dis_poker.length &&
                                            item.dis_poker.map((item2, index2) => (
                                                <img
                                                    key={index2}
                                                    className="board-img"
                                                    src={getCardUrl(item2)}
                                                />
                                            ))}
                                    </Col>
                                </Row>
                            }
                        />
                    ))}
                </Card>
            )}
        </>
    );
}
